import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

export default function Vision() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="vision" ref={ref} data-testid="vision-section" className="relative py-28 lg:py-44 bg-surface overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 z-0 opacity-20">
        <img src={IMAGES.boardroom} alt="" className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-surface via-surface/85 to-surface" />
      <div className="relative z-20 mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal><SectionLabel>{t.vision.eyebrow}</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl text-white mt-8 max-w-4xl leading-[1.05] tracking-[-0.01em]">
            {t.vision.title}
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="font-serif italic text-xl sm:text-2xl text-gold leading-snug mt-10 max-w-3xl border-l-2 border-gold pl-8">
            {t.vision.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
